/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_CancelInputs */

const en_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_speaker_manager_merge_cancel = /** @type {(inputs: Speaker_Manager_Merge_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Speaker_Manager_Merge_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_cancel = /** @type {((inputs?: Speaker_Manager_Merge_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_merge_cancel(inputs)
	if (locale === "de") return de_speaker_manager_merge_cancel(inputs)
	if (locale === "it") return it_speaker_manager_merge_cancel(inputs)
	if (locale === "ru") return ru_speaker_manager_merge_cancel(inputs)
	if (locale === "es") return es_speaker_manager_merge_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_merge_cancel(inputs)
	if (locale === "ja") return ja_speaker_manager_merge_cancel(inputs)
	if (locale === "hi") return hi_speaker_manager_merge_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_merge_cancel(inputs)
	return en_speaker_manager_merge_cancel(inputs)
});